import { Components } from "@thisgorilla/primate-ds";
import Cropper from "react-easy-crop";
import { useTheme } from "styled-components";
import CropImageModalProps from "../CropImageModal";
import {
  ButtonWrapper,
  Container,
  CustomSlider,
  Image,
  ImageContainer,
  ModalBodyContainer,
  SliderContainer,
} from "./style";
import { FlexRow } from "../../../../../Common/Styles";

const ModalBody = ({
  imageUrl,
  crop,
  zoom,
  rotation,
  setCrop,
  setZoom,
  setRotation,
  onCropComplete,
  croppedImage,
  isCroppedView,
  setIsCroppedView,
}: CropImageModalProps.ModalBody) => {
  const { typography } = useTheme();

  return (
    <ModalBodyContainer>
      {isCroppedView ? (
        <div>
          {croppedImage && (
            <ImageContainer>
              <Image
                src={URL.createObjectURL(croppedImage)}
                alt="cropped-image-preview"
              />
              <ButtonWrapper>
                <Components.IconButton
                  disabled={false}
                  iconType="Crop"
                  kind="Floating"
                  size="Medium"
                  onClick={() => setIsCroppedView(false)}
                />
              </ButtonWrapper>
            </ImageContainer>
          )}
        </div>
      ) : (
        <Container>
          <Cropper
            image={imageUrl}
            crop={crop}
            zoom={zoom}
            minZoom={1}
            maxZoom={3}
            zoomSpeed={0.4}
            aspect={1090 / 213}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
            rotation={rotation}
            onRotationChange={setRotation}
          />
        </Container>
      )}
      <FlexRow $gapInPx={2}>
        <Components.Text
          style={{ tokenStyle: typography.Body.M }}
          text="Recommended Size: "
          lineHeight="line-height-100"
        />
        <Components.Text
          style={{ tokenStyle: typography.Body.M }}
          text=" 3600 x 410 Pixels"
          lineHeight="line-height-100"
          fontWeight="font-weight-semibold"
        />
      </FlexRow>
      {!isCroppedView && (
        <SliderContainer $gapInPx={96}>
          <SliderContainer $gapInPx={8}>
            <Components.IconButton
              iconType="Minus"
              disabled={zoom === 1}
              kind="Tertiary"
              onClick={() => {
                setZoom((prev) => (prev - 0.2 > 1 ? prev - 0.2 : 1));
              }}
              size="XS"
            />
            <CustomSlider
              type="range"
              min={1}
              max={3}
              step={0.2}
              value={zoom}
              onChange={(e) => setZoom(Number(e.target.value))}
              $value={((zoom - 1) * 100) / 2}
            />
            <Components.IconButton
              iconType="Plus"
              disabled={zoom === 3}
              kind="Tertiary"
              onClick={() => {
                setZoom((prev) => (prev + 0.2 > 3 ? 2 : prev + 0.2));
              }}
              size="XS"
            />
          </SliderContainer>
          <SliderContainer $gapInPx={8}>
            <Components.IconButton
              iconType="RotateCcw"
              disabled={rotation === 0}
              kind="Tertiary"
              onClick={() => {
                setRotation((prev) => (prev - 1 > 0 ? prev - 1 : 0));
              }}
              size="XS"
            />
            <CustomSlider
              type="range"
              min={0}
              max={360}
              step={1}
              value={rotation}
              onChange={(e) => setRotation(Number(e.target.value))}
              $value={(rotation * 100) / 360}
            />
            <Components.IconButton
              iconType="RotateCw"
              disabled={rotation === 360}
              kind="Tertiary"
              onClick={() => {
                setRotation((prev) => (prev + 1 > 360 ? 360 : prev + 1));
              }}
              size="XS"
            />
          </SliderContainer>
        </SliderContainer>
      )}
    </ModalBodyContainer>
  );
};

export default ModalBody;
